import React from 'react'

export default function Button({ link, title}) {
    return (
        <a href={link} class="button is-size-2">{title}</a>
    )
}
